module.exports = __webpack_public_path__ + "static/img/sr395.12d1701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/sr395.jpg
// module id = Ha/b
// module chunks = 0